module.exports = {
      id: "expand-usage",
      viewBox: "0 0 28 24",
      url: __webpack_public_path__ + "assets/img/sprite-8cafc1.svg#expand-usage",
      toString: function () {
        return this.url;
      }
    }